import React, {Component} from "react";
import {CircularProgress, Typography, withStyles} from "@material-ui/core";
import {Redirect, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {bindActionCreators, compose} from "redux";
import {push} from 'react-router-redux';
import {messaging} from "../firebase";

const firebaseMessaging= messaging();

const styles = theme => ({
    root: {
        height: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing.unit*2,
    }
});

class ConnectionCheck extends Component {
    constructor() {
        super();

        this.state = {
            loading: true,
            error: null,
        }
    }

    async componentDidMount() {
        const {push, hasData} = this.props;
        if (!hasData) {
            return;
        }
        try {
            const token = !!firebaseMessaging && await firebaseMessaging.getToken();
            !!token ? push('/register/push/verify') : push('/landing');
        } catch(e) {
            console.debug("messaging.getToken() error", e);
            push('landing');
        }

    }

    render() {
        const {classes, hasData} = this.props;
        const {loading} = this.state;

        if (!hasData) {
            return (
                <div className={classes.root}>
                    <Typography variant="display3" color="primary" className={classes.title}>
                        Hoppsan!
                    </Typography>
                    <Typography variant="display1" color="primary">
                        Använder du verkligen ett Pantanova WiFi?
                    </Typography>
                </div>
            )
        }

        if (loading) {
            return (
                <div className={classes.root}>
                    <CircularProgress className={classes.progress} size={100} />
                </div>
            );
        }

        return (
            <Redirect to="/landing" />
        );
    }
}

ConnectionCheck.propTypes = {};
ConnectionCheck.defaultProps = {};

const mapStateToProps = (state) => ({
    hasData: !!state.wifi.mac && !!state.wifi.ap,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    push
}, dispatch);

export default compose(
    withRouter,
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps),
)(ConnectionCheck);



// WEBPACK FOOTER //
// ./src/containers/ConnectionCheck.js